import { render } from "./DcHeros.vue?vue&type=template&id=3dae010c"
import script from "./DcHeros.vue?vue&type=script&lang=js"
export * from "./DcHeros.vue?vue&type=script&lang=js"
script.render = render

export default script